import React from 'react';
import AvatarIcon from 'components/features/utils/AvatarIcon';

type Props = {
  title: string;
};

export const AchievedComment: React.FC<Props> = props => {
  return (
    <>
      <div>
        <div className="flex flex-row items-center">
          <AvatarIcon icon={'veryGood'} />
          <div className="ml-4 text-base font-bold">
            目標達成おめでとうございます！
          </div>
        </div>
        <div className="mt-2 text-sm">
          <div>「{props.title}」の目標金額を達成しました。お疲れ様でした！</div>
          <div>引き続き新しい目標をたてて、資産形成を進めていきましょう。</div>
        </div>
      </div>
    </>
  );
};
